import { Link } from 'react-router';

/** Captions icon in a dark rounded square + wordmark. */
export function LogoMark({ size = 32, tone = 'dark' }: { size?: number; tone?: 'dark' | 'light' }) {
  return (
    <span
      className={`inline-flex shrink-0 items-center justify-center rounded-lg ${tone === 'dark' ? 'bg-ink text-white' : 'bg-white text-ink'}`}
      style={{ width: size, height: size }}
      aria-hidden
    >
      <svg
        viewBox="0 0 24 24"
        width={size * 0.56}
        height={size * 0.56}
        fill="none"
        stroke="currentColor"
        strokeWidth="2"
      >
        <rect x="3" y="5" width="18" height="14" rx="2.5" />
        <path d="M7 11h3M7 15h6M13 11h4M16 15h1" strokeLinecap="round" />
      </svg>
    </span>
  );
}

/** `tone="light"` is for dark backgrounds. */
export function Logo({
  to = '/',
  size = 32,
  tone = 'dark',
}: {
  to?: string;
  size?: number;
  tone?: 'dark' | 'light';
}) {
  return (
    <Link to={to} className="flex items-center gap-2.5 rounded-lg">
      <LogoMark size={size} tone={tone} />
      <span className={`text-[17px] font-bold tracking-tight ${tone === 'dark' ? 'text-ink' : 'text-white'}`}>
        AICAPTION
      </span>
    </Link>
  );
}
